import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectModule } from 'primeng/select';
import { FormsModule } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../services/language.service';

interface Language {
  code: string;
  name: string;
}

@Component({
  selector: 'app-language-switcher',
  standalone: true,
  imports: [CommonModule, SelectModule, FormsModule],
  templateUrl: './language-switcher.component.html',
  styleUrls: ['./language-switcher.component.scss']
})
export class LanguageSwitcherComponent implements OnInit {
  currentLanguage = 'en';
  
  languages: Language[] = [
    { code: 'en', name: 'EN' },
    { code: 'it', name: 'IT' },
    { code: 'fr', name: 'FR' }
  ];

  constructor(
    private translate: TranslateService,
    private cdr: ChangeDetectorRef,
    private languageService: LanguageService
  ) {}

  ngOnInit() {
    // Get current language from the language service
    this.currentLanguage = this.languageService.getCurrentLanguage();
  }

  onLanguageChange(languageCode: string): void {
    this.currentLanguage = languageCode;
    this.languageService.setLanguage(languageCode);
    this.cdr.detectChanges();
  }
}
